import type * as React from "react";

import { cn } from "../lib/cn";

export type OrderRoute = "treatment" | "desk" | "brian";

const routeLabel: Record<OrderRoute, string> = {
  treatment: "Treatment",
  desk: "Desk",
  brian: "Brian",
};

export interface RoutingTagProps extends Omit<
  React.HTMLAttributes<HTMLSpanElement>,
  "children"
> {
  route: OrderRoute;
  ref?: React.Ref<HTMLSpanElement>;
}

export function RoutingTag({ route, className, ...rest }: RoutingTagProps) {
  return (
    <span
      className={cn(
        "inline-block whitespace-nowrap rounded-tag border border-rule-strong px-2 py-0.5",
        "font-mono text-fine-print uppercase leading-none tracking-[0.08em] text-annotation",
        className,
      )}
      {...rest}
    >
      {routeLabel[route]}
    </span>
  );
}
